module.exports = __webpack_public_path__ + "static/media/Rahul.caf51061.jpg";